import { initAccordion } from "./accordion";
import { initSpecialties } from "./specialties";
import { initNav } from "./nav";
import { initForm } from "./form";
import { initAnimate } from "./animate";

const isBricksBuilder = () => Number(window.ambidryTheme?.isBuilder) === 1;

const boot = () => {
  if (!isBricksBuilder()) {
    initAnimate();
  }
  initNav();
  if (!document.body.classList.contains("custom-landing-page")) {
    return;
  }

  initAccordion();
  initSpecialties();
  initForm();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
